module.exports = __webpack_public_path__ + "img/1558357491.7fd04623.jpg";